export const MM_PER_INCH = 25.4
export const MM_PER_PT = 25.4 / 72

export function mmToPx(mm: number, pxPerMm: number): number {
  return mm * pxPerMm
}

export function pxPerMmForDpi(dpi: number): number {
  return dpi / MM_PER_INCH
}

export function ptToMm(pt: number): number {
  return pt * MM_PER_PT
}

/** Effektive Auflösung eines Bildausschnitts, der auf `widthMm` gedruckt wird. */
export function effectiveDpi(sourcePx: number, widthMm: number): number {
  if (!(sourcePx > 0) || !(widthMm > 0)) return 0
  return sourcePx / (widthMm / MM_PER_INCH)
}
